export const SERVER_ERROR_TYPES = {
  FAILED_TO_REFRESH_TOKEN: "FAILED_TO_REFRESH_TOKEN",
  UNAUTHORIZED: "UNAUTHORIZED",
  UNKNOWN: "UNKNOWN",
  UPDATE_VERSION: "UPDATE_VERSION",
};
